import { ItemPart } from "./ItemPart";

import rcolor from "rcolor";
//https://github.com/sterlingwes/RandomColor
//https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/

export class Item {
	checked: boolean;
	hidden: boolean;
	id: string;
	loadingParameters: any;

	fileId: number;
	name: string;
	src: string;
	localSrc: string;
	inputSize: any;

	innerVideoResolutionX: number;
	innerVideoResolutionY: number;

	fps: number;
	duration: number;
	size: number;
	bitrate: number;
	thumbs: string[];
	color: string;

	isOutsize: boolean;

	autocutParameters: any;
	bitrateGraph: any;

	lastItemIndex: number;

	parts: ItemPart[];

	constructor() {
		this.id = `f${(~~(Math.random() * 1e8)).toString(16)}`;
		this.hidden = false;
		this.fileId = 0;
		this.name = '';
		this.src = '';
		this.localSrc = null;
		this.inputSize = null;

		this.loadingParameters = {
			loaded: false,
			uploadingId: "",
			process: 0,
			localThumbs: []
		}

		this.innerVideoResolutionX = 0;
		this.innerVideoResolutionY = 0;

		this.fps = 0;
		this.duration = 0;
		this.size = 0;
		this.bitrate = 0;
		this.thumbs = [];
		this.isOutsize = false;
		this.color = rcolor();//'#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');

		this.autocutParameters = {
			partsCount: 1,
			partsDurations: 1,
			isReadyToAutocut: false,
			process: 0
		}

		this.bitrateGraph = null;
		this.lastItemIndex = 1;

		this.parts = [];
	}

	static createNewItemByFile(file: File, videoFileParameters: any, uploadingId: string) {
		let newItem = new Item();

		newItem.fileId = null;
		newItem.name = file.name.split('.').slice(0, -1).join('.');
		newItem.src = null;
		newItem.localSrc = window.URL.createObjectURL(file);
		newItem.inputSize = null;

		newItem.loadingParameters = {
			loaded: false,
			uploadingId: uploadingId,
			process: 0,
			localThumbs: []
		}
		this.generateLocalBase64Thumbs(
			newItem.localSrc,
			newItem.loadingParameters
		);

		newItem.innerVideoResolutionX = videoFileParameters.videoWidth;
		newItem.innerVideoResolutionY = videoFileParameters.videoHeight;

		newItem.fps = 0;
		newItem.duration = videoFileParameters.duration;
		newItem.size = 0;
		newItem.bitrate = 0;
		newItem.thumbs = [];
		//this.isOutsize = false;

		return newItem;
	}

	parseToShortObject() {
		return {
			id: this.id,
			fileId: this.fileId,
			name: this.name,
			inputSize: this.inputSize,
			innerVideoResolutionX: this.innerVideoResolutionX,
			innerVideoResolutionY: this.innerVideoResolutionY,
			fps: this.fps,
			duration: this.duration,
			size: this.size,
			bitrate: this.bitrate,
			isOutsize: this.isOutsize,
			color: this.color
		};
	}

	static copyFromParsed(itemToCopy): Item {
		let newItem = new Item();

		newItem.id = itemToCopy.id;
		newItem.fileId = itemToCopy.fileId;
		newItem.checked = itemToCopy.checked;
		newItem.hidden = Boolean(itemToCopy.hidden);
		newItem.name = itemToCopy.name;
		newItem.src = itemToCopy.src;

		//WARN: Don't update local src. After parsing it will be null!
		newItem.localSrc = null;

		newItem.loadingParameters.loaded = true
		newItem.loadingParameters.process = 100;

		//newItem.inputSize = JSON.parse(JSON.stringify(itemToCopy.inputSize));
		//newItem.inputSize = JSON.parse(JSON.stringify(Item.getVideoSize(itemToCopy.inputSize.name)));

		newItem.innerVideoResolutionX = itemToCopy.innerVideoResolutionX;
		newItem.innerVideoResolutionY = itemToCopy.innerVideoResolutionY;

		newItem.fps = itemToCopy.fps;
		newItem.duration = itemToCopy.duration;
		if (itemToCopy.size) {
			newItem.size = itemToCopy.size;
		}
		if (itemToCopy.bitrate) {
			newItem.bitrate = itemToCopy.bitrate;
		}
		newItem.thumbs = JSON.parse(JSON.stringify(itemToCopy.thumbs));
		newItem.isOutsize = itemToCopy.isOutsize;
		newItem.color = itemToCopy.color && itemToCopy.color !== "" ? itemToCopy.color : newItem.color;

		newItem.autocutParameters = JSON.parse(JSON.stringify(itemToCopy.autocutParameters));

		newItem.bitrateGraph = JSON.parse(JSON.stringify(itemToCopy.bitrateGraph ? itemToCopy.bitrateGraph : null));
		newItem.lastItemIndex = itemToCopy.lastItemIndex ? itemToCopy.lastItemIndex : 1;

		itemToCopy.parts.forEach(part => {
			let itemPart = ItemPart.copyFromParsed(part);
			itemPart.parentItemInfo = newItem.parseToShortObject();
			newItem.parts.push(itemPart);

		});


		return newItem;
	}

	addNewItemPart(startTime, finishTime) {
		if (startTime < 0 || startTime > this.duration) {
			startTime = 0;
		}
		if (finishTime < 0 || finishTime > this.duration) {
			finishTime = this.duration;
		}
		let newItemPart = new ItemPart(startTime, finishTime, "Part_" + this.lastItemIndex);
		this.lastItemIndex++;
		newItemPart.parentItemInfo = this.parseToShortObject();
		this.parts.push(newItemPart);
	}

	static generateLocalBase64Thumbs(
		videoLocalSrc,
		loadingParameters
	) {
		let videoEl: HTMLVideoElement = document.createElement("video");
		videoEl.style.display = "none";
		document.body.append(videoEl);
		videoEl.src = videoLocalSrc;
		videoEl.muted = true;

		videoEl.addEventListener("loadedmetadata", async function (e) {
			let count =
				videoEl.duration <= 10 ? Math.ceil(videoEl.duration) : 10;
			let canvas = document.createElement("canvas");
			let ctx = canvas.getContext("2d");
			let ch = 200;

			videoEl.play();

			let seekResolve;
			videoEl.addEventListener("seeked", async function () {
				if (seekResolve) seekResolve();
			});

			let frameWidth =
				(videoEl.videoWidth * ch) / videoEl.videoHeight;
			canvas.width = frameWidth;
			canvas.height = ch;
			let range = videoEl.duration / count;
			ctx.clearRect(0, 0, canvas.width, ch);
			let localThumbs = [];

			for (let i = 0; i < count; i++) {
				videoEl.currentTime = range * i;
				await new Promise((r) => (seekResolve = r));
				ctx.drawImage(videoEl, 0, 0, frameWidth, ch);
				localThumbs.push(canvas.toDataURL("image/png"));
				if (i === count - 1) {
					loadingParameters.localThumbs = localThumbs;
					videoEl.remove();
				}
			}
		});
	}
}
